"use client";
import React from "react";
import CustomCard from "./CustomCard";
import BarGraphFianancial from "./BarGraphFianancial";

const Financials = () => {
  const series = [
    {
      name: "Net Profit",
      data: [
        9021, 8022, 7010, 7228, 8116, 9221, 9013, 3030, 8932, 6634, 7396, 9938,
      ],
    },
  ];
  const series1 = [
    {
      name: "EPS",
      data: [
        15.2, 15.62, 16.1, 17.28, 18.16, 29.21, 19.13, 13.3, 19.32, 16.34,
        17.96, 19.38,
      ],
    },
  ];
  const series2 = [
    {
      name: "Revenue",
      data: [
        9021, 8022, 7010, -3030, 8116, 9221, 9013, 7228, 8932, 6634, 7396, 9938,
      ],
    },
  ];
  const series3 = [
    {
      name: "Total assets",
      data: [
        9021, 8022, 7010, 7228, 8116, 9221, 9013, 3030, 8932, 6634, 7396, 9938,
      ],
      color: "#26ABA4",
    },
    {
      name: "Total liabilities",
      data: [
        8021, 9022, 6010, 7228, 9116, 8221, 7013, 4030, 7932, 8634, 8396, 8938,
      ],
      color: "#F6A352",
    },
  ];
  const series4 = [
    {
      name: "Cash flow",
      data: [
        9021, 8022, 7010, -3030, 8116, 9221, -4013, 7228, 8932, -2634, 7396,
        9938,
      ],
    },
  ];

  return (
    <div className="m-4">
      <p className="font-bold text-2xl text-[#333333] mb-4">Financials</p>
      <div className="flex flex-row gap-4">
        <CustomCard
          title={"Compounded Sales Growth"}
          tenyearvalue={"21%"}
          fiveyearvalue={"22%"}
          threeyearvalue={"30%"}
          ttmvalue={"65%"}
        />
        <CustomCard
          title={"Compounded Profit Growth"}
          tenyearvalue={"22%"}
          fiveyearvalue={"23%"}
          threeyearvalue={"26%"}
          ttmvalue={"66%"}
        />
        <CustomCard
          title={"Stock Price CAGR"}
          tenyearvalue={"14%"}
          fiveyearvalue={"5%"}
          threeyearvalue={"1%"}
          oneyearvalue={"2%"}
        />
        <CustomCard
          title={"Return on Equity"}
          tenyearvalue={"18%"}
          fiveyearvalue={"17%"}
          threeyearvalue={"19%"}
        />
      </div>
      <div className="flex flex-row flex-wrap gap-5">
        <BarGraphFianancial title={"Net Profit"} series={series} />
        <BarGraphFianancial title={"Eps"} series={series1} />
        <BarGraphFianancial title={"Revenue"} series={series2} />
        <BarGraphFianancial
          title={"Balance Sheet"}
          series={series3}
          type={true}
        />
        <BarGraphFianancial title={"Cash Flow"} series={series4} />
      </div>
    </div>
  );
};

export default Financials;
